module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-500-latin-ext8.d035c4a.woff2";